
import * as orderTypeEnum from '~/enums/order-type'
import { isBuyOrder } from '~/utils/order-type'
import { types as productTypes } from '~/utils/product-item-type'
import ApiErrorMessage from '../api-error-message/api-error-message.vue'

const BALANCE_ERRORS = ['WALLET_NOT_ENOUGH_BALANCE', 'NOT_ENOUGH_BALANCE']

export default {
  components: {
    ApiErrorMessage,
  },
  props: {
    orderType: {
      type: String,
      required: true,
      validator: (val) =>
        [orderTypeEnum.values.Buy, orderTypeEnum.values.Sell].includes(val),
    },
    submitText: {
      type: String,
      required: true,
    },
    confirmationText: {
      type: String,
      required: true,
    },
    saveState: {
      type: Object,
      required: true,
    },
    itemType: {
      type: String,
      required: true,
      validator: (val) => Object.values(productTypes).includes(val),
    },
    itemIsAnchored: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      hasAcceptedTerms: false,
      disableCancel: false,
    }
  },
  computed: {
    isOrderTypeBuy() {
      return isBuyOrder(this.orderType)
    },

    showAnchoredItemsCheckbox() {
      return (
        this.isOrderTypeBuy &&
        this.itemIsAnchored &&
        this.$isBottle({ itemType: this.itemType })
      )
    },

    showDepositButton() {
      return this.saveState.error
        ? BALANCE_ERRORS.includes(
            this.saveState.error.originalResponse.data.instance,
          )
        : false
    },

    canSubmit() {
      return !this.showDepositButton
    },

    disableSubmit() {
      return this.showAnchoredItemsCheckbox && !this.hasAcceptedTerms
    },
  },
}
